import {EventEmitter, Injectable } from '@angular/core';
import { StoreKeyEnum } from '@lib/enums';
import {LoggedUserInterface} from "@lib/interfaces";

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  private storage: Storage;

  constructor(
  ) {
    this.storage = window.localStorage;
  }

  public get(key: string): string {
    const item = this.storage.getItem(key);
    return !!item ? item : null;
  }

  public set(key: string, value: string): void {
    this.storage.setItem(key, value);
  }

  public clear(key: string): void {
    this.storage.removeItem(key);
  }

  public getToken(): string {
    const storeValue = this.storage.getItem(StoreKeyEnum.token);

    let token: any;

    try {
      token = (JSON.parse(storeValue) as LoggedUserInterface).access_token;
    } catch (error) {
      this.clearToken();
    }
    return token ? token : null;
  }

  public clearToken(): void {
    this.storage.removeItem(StoreKeyEnum.token);
  }

  public setUser(value: string) {
    this.set(StoreKeyEnum.token, value);
  }
}
